import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ImageService {
    /**
     * Available screen widths, sorted from the smallest to the largest.
     */
    public static readonly SCREEN_WIDTHS = [
        600, 768, 800, 820, 853, 900, 1024, 1080, 1180, 1280, 1440, 1600, 1920,
        2160, 2560, 2880, 3440, 3840,
    ].sort((a, b) => a - b);
    private static readonly MIN_SCREEN_THRESHOLD = 1024;

    /**
     * Returns the optimized image URL width based on screen width.
     */
    public getAppropriateImageWidth(): number {
        // Get current viewport width
        const documentElement = document.documentElement;
        let minImageWidth =
            window.innerWidth ||
            documentElement.clientWidth ||
            documentElement.getElementsByTagName('body')[0].clientWidth;

        if (minImageWidth < ImageService.MIN_SCREEN_THRESHOLD) {
            // for screens smaller than MIN_SCREEN_THRESHOLD, use double width images for better results
            minImageWidth = minImageWidth * 2;
        }

        // Find the appropriate image size (next size up from screen width; fallback to the largest)
        return (
            ImageService.SCREEN_WIDTHS.find((size) => size >= minImageWidth) ||
            ImageService.SCREEN_WIDTHS.at(-1)!
        );
    }
}
